import { get, } from '.';

export function GetCommandList(options = {}) {
	return get<any>("/app/api/get_command_list", options);
}